import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const headingPadding = 'px-2xl sm:px-3xl md:px-4xl lg:px-0';

export const Container = createComponent('div', {
  className: 'flex justify-center bg-canvas-default py-4xl sm:py-7xl lg:px-4xl'
});

export const Wrapper = createComponent('div', {
  className: 'grid w-full max-w-[1272px] gap-2xl'
});

export const Headline = createComponent('h2', {
  className: cx(headingPadding, 'text-text-strong t-heading-2xl')
});

export const SubHeadline = createComponent('p', {
  className: cx(headingPadding, 'text-text-default t-body-sm')
});

export const ReviewCardContainer = createComponent('div', {
  className: cx(
    'flex h-full w-[300px] flex-col justify-between gap-xl rounded-md border border-border-subtle p-2xl sm:w-[339px] md:w-[309px] lg:w-[389px] xl:w-[412px]'
  )
});
